<template>
  <div class="home">
    <div class="body">
      <div class="top">
        <div class="date">
          <div>
            <img src="https://img.icons8.com/?size=512&id=vrjuWgj4Ipxl&format=png" height="40"
              style="margin-right: 10px" />
            <div class="akun">
              <p style="margin: 0">
                <b>{{ $user.nama }}</b>
              </p>
              <span>{{ $user.divisi }}</span>
            </div>
          </div>
          <div class="logout" @click="logout">
            <logout />
          </div>
        </div>

        <div class="filter-bar" v-if="$user.access == 'ADMIN'">
          <div class="filter-box" :class="{ active: openFilter }" @click="openFilter = !openFilter">
            <span>Filter</span>
            <span class="down">
              <right />
            </span>
          </div>
          <div class="filter-content" v-if="openFilter">
            <form @submit.prevent="loadAll">
              <div class="form-group">
                <label>User</label>
                <select v-model="filter.user">
                  <option value="ALL">Semua</option>
                  <option v-for="(item, index) in user" :key="index" :value="item.id">
                    {{ item.nama }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-primary">Filter</button>
              </div>
            </form>
          </div>
        </div>

        <div class="summary">
          <div class="home-top">
            <div>
              <h3>Home</h3>
            </div>
            <div v-if="$user.access == 'ADMIN'">
              <router-link to="/laporan">Laporan</router-link>
            </div>
          </div>

          <div class="grid">
            <div class="card todo" :class="{ skeleton: loading }" @click="detail('TODO')">
              <h1>{{ summary.TODO }}</h1>
              <p>Todo</p>
            </div>
            <div class="card progress" :class="{ skeleton: loading }" @click="detail('IN_PROGRESS')">
              <h1>{{ summary.IN_PROGRESS }}</h1>
              <p>In Progress</p>
            </div>
            <div class="card complete" :class="{ skeleton: loading }" @click="detail('COMPLETE')">
              <h1>{{ summary.COMPLETE }}</h1>
              <p>Complete</p>
            </div>
            <div class="card all" :class="{ skeleton: loading }" @click="detail('TERLAMBAT')">
              <h1>{{ summary.TERLAMBAT }}</h1>
              <p>Terlambat</p>
            </div>
          </div>
        </div>
      </div>

      <div class="task penilaian"  v-if="$user.access == 'ADMIN'">
        <h3>Penilaian Manajemen</h3>
        <router-link to="/penilaian-manajemen">
          Lihat penilaian manajemen
        </router-link>
      </div>

      <div class="task">
        <h3>Target terdekat</h3>
        <div class="">
          <div class="loading" v-show="loading">
            <div class="skeleton" v-for="(item, index) in [1, 1, 1, 1]" :key="index"></div>
          </div>

          <div v-show="data.length <= 0 && !loading" class="mt">
            <p>Tidak ada pekerjaan</p>
            <router-link to="/add?editable=true" class="btn">
              Tambahkan pekerjaan
            </router-link>
          </div>

          <ul>
            <li v-for="(item, index) in data" :key="index">
              <div>
                <p>{{ item.nama }}</p>
                <small v-show="item.diff > 0">{{
                  Math.abs(item.diff) + " hari lagi"
                }}</small>
                <small class="red" v-show="item.diff < 0">
                  {{
                    "Target selesai pada tanggal " +
                    moment(item.tgl_target).format("DD/MM/YY")
                  }}
                </small>
              </div>
              <div>
                <span class="badge" :class="item.status.toLowerCase()">{{
                  item.status.replace("_", " ").toLowerCase()
                }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="summary" style="margin-top: 15px" v-show="$user.access == 'ADMIN'">
        <h3>Pekerjaan belum selesai</h3>
        <div class="crat">
          <v-chart class="chart" :option="chartOptions" autoresize />
        </div>

        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Todo</th>
              <th>In Progress</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in incomplete" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.TODO }}</td>
              <td>{{ item.IN_PROGRESS }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="task" v-if="false">
        <div class="task-filter">
          <div>
            <h3>Tugas</h3>
          </div>
          <div v-if="$user.access == 'ADMIN'">
            <!-- <select v-model="taskFilter" @change="loadAll">
              <option value="ALL_TASK">Semua Tugas</option>
              <option value="MY_TASK">Tugas Saya</option>
            </select> -->
          </div>
        </div>
        <div v-if="data.length <= 0">
          <p style="text-align: center; margin-top: 60px">Tidak ada tugas</p>
        </div>
        <ul>
          <li v-for="(item, index) in data" :key="index" :class="item.status == 'COMPLETE'
              ? 'complete'
              : item.diff < 0 && item.status != 'COMPLETE'
                ? 'danger'
                : item.diff <= 3 && item.status != 'COMPLETE'
                  ? 'warning'
                  : ''
            " @click="to('/detail/' + item.id + '?editable=true')">
            <div>
              <div v-if="$user.access == 'ADMIN'">
                <small>{{ item.user }}</small>
              </div>
              <p>{{ item.nama }}</p>
              <small>
                {{
                  item.diff > 0
                  ? Math.abs(item.diff) + " hari lagi"
                  : "Target selesai pada tanggal " +
                  moment(item.tgl_target).format("DD/MM/YY")
                }}
              </small>
            </div>
            <div>
              <right />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from "./icons/Calendar.vue";
import Right from "./icons/Right.vue";
import Logout from "./icons/Logout.vue";

import moment from "moment";
import * as api from "./../api/Api";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "Home",
  components: {
    Calendar,
    Right,
    Logout,
    VChart,
  },
  data() {
    return {
      summary: {
        TODO: 0,
        IN_PROGRESS: 0,
        COMPLETE: 0,
        CANCEL: 0,
        ALL: 0,
        TERLAMBAT: 0,
      },
      taskFilter: "MY_TASK",
      data: [],
      loading: false,
      filter: {
        divisi: "ALL",
        user: "ALL",
      },
      openFilter: false,
      divisi: [],
      user: [],

      chartOptions: {},
      incomplete: [],
    };
  },
  methods: {
    moment,
    logout() {
      localStorage.clear();
      location.reload();
    },
    to(to) {
      setTimeout(() => {
        this.$router.push(to);
      }, 150);
    },
    detail(status) {
      setTimeout(() => {
        this.$router.push(
          "/task?id_user=" + this.filter.user + "&status=" + status
        );
      }, 150);
    },
    loadAll() {
      this.loadSummary();
      this.loadData();
    },
    loadSummary() {
      this.loading = true;

      let param = "";
      if (this.$user.access == "ADMIN") {
        param = "id_user=" + this.filter.user;
      } else {
        param = "id_user=" + this.$user.id;
      }

      api
        .get("/v1/kendali_kerja/pekerjaanController/summary?" + param)
        .then((r) => {
          this.summary = {
            TODO: 0,
            IN_PROGRESS: 0,
            COMPLETE: 0,
            CANCEL: 0,
            ALL: 0,
          };

          r.data.forEach((item) => {
            this.summary[item.status] = item.total;
          });

          this.summary.ALL =
            parseInt(this.summary.TODO) +
            parseInt(this.summary.IN_PROGRESS) +
            parseInt(this.summary.COMPLETE);

          this.loading = false;
        });
    },
    loadData() {
      let param = "";
      if (this.$user.access == "ADMIN") {
        param = "id_user=" + this.filter.user;
      } else {
        param = "id_user=" + this.$user.id;
      }

      api
        .get("/v1/kendali_kerja/pekerjaanController/getTargetTerdekat?" + param)
        .then((r) => {
          if (r.valid) {
            this.data = r.data;
          }
        });
    },
    loadUser() {
      this.user = this.$store.state.user.data;
    },
    setup() {
      api
        .get("/v1/kendali_kerja/pekerjaanController/chart?status=INCOMPLETE")
        .then((r) => {
          this.incomplete = r.data;
          const option = {
            title: {
              text: "",
            },
            tooltip: {
              trigger: "item",
              formatter: "{b} : {c} ({d}%)",
            },
            series: [
              {
                type: "pie",
                data: r.data,
              },
            ],
          };

          this.chartOptions = option;
        });
    },
  },
  mounted() {
    if (this.$user.access == "ADMIN") {
      this.loadUser();

      this.filter.user = this.$user.id;
    }

    this.loadSummary();
    this.loadData();
    this.setup();
  },
};
</script>

<style scoped lang="scss">
.home {
  border: 10px solid #fff;

  .body {
    padding-bottom: 55px;

    .top {
      background: #fff;
      border-radius: 0 0 20px 20px;
    }

    .date {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      font-weight: 500;
      margin-bottom: 20px;

      >div {
        display: flex;
        align-items: center;
        font-size: 14px;

        &.logout {
          border-radius: 20px;

          &:active {
            background: #eee;
          }
        }

        .icon {
          width: 20px;
        }

        .card {
          padding: 15px;
        }
      }
    }

    .summary {
      margin: 0 10px 20px;
      padding-bottom: 15px;
      background: #fff;
      border-radius: 15px;

      .home-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        h3 {
          margin: 0;
        }

        a {
          text-decoration: none;
          color: #009be7;
        }
      }

      .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
        grid-row-gap: 15px;
      }

      .card {
        border-radius: 6px;
        padding: 20px;
        color: #333;
        border: 1px solid #ccc;

        &:active {
          background: #f7f7f7;
        }

        h1,
        p {
          margin: 0;
          text-align: center;
        }

        p {
          font-weight: 500;
          font-size: 14px;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;

        tr {
          th {
            font-size: 14px;

            &:first-child {
              text-align: left;
            }
          }

          td {
            font-size: 14px;
            padding: 15px 0;
            border-bottom: 1px solid #ddd;

            &:nth-child(2),
            &:nth-child(3) {
              text-align: center;
            }
          }
        }
      }
    }
  }

  .mt {
    text-align: center;
    padding: 20px 0;

    a.btn {
      display: block;
      text-decoration: none;
      font-size: 12px;
      width: 160px;
      margin: 20px auto;
    }
  }

  .filter-bar {
    margin: 0 10px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;

    .filter-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;

      &.active {
        padding-bottom: 10px;
        border-bottom: 1px solid #ccc;

        span.down {
          .icon {
            transform: rotate(-90deg);
          }
        }
      }

      span {
        &.down {
          .icon {
            transform: rotate(90deg);
            width: 15px;
          }
        }
      }
    }

    .filter-content {
      margin-top: 10px;

      label {
        display: block;
        margin-bottom: 5px;
      }

      select {
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 5px;
      }

      .form-group {
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .card.skeleton {
    border: 0 !important;

    h1,
    p {
      opacity: 0;
    }
  }

  .loading {
    .skeleton {
      min-height: 42px;
      border-radius: 4px;
      margin-bottom: 15px;
    }
  }

  .crat {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 240px;
    margin-bottom: 30px;
  }
}

.penilaian {
  a {
    background: var(--primary);
    color: #fff;
    text-decoration: none;
    display: block;
    font-size: 12px;
    padding: 15px;
    border-radius: 6px;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue